// extracted by mini-css-extract-plugin
export default {"container-modal":"styles_container-modal__10Yoj"};